import { ServiceValues } from '../values/ServiceValues';
import { ServiceAxios } from './ServiceEW';
import { Values } from '../values/Values';


async function getAllEstoqueInsumoMovimentacao(limit, page) {
  const timeout = ServiceValues.timeout;
  const baseUrl = ServiceValues.base_url_local;
  const api = ServiceAxios(baseUrl, timeout);
  try {
    const params = {
      limit: limit,
      page: page
    };
    const dados = await api.get('estoque-insumo-movimentacao/', { params: params });
    if (dados) {
      if (dados.data) {
        return dados.data;
      }
      else {
        return {
          isSuccess: false,
          message: Values.MessageValues.erro_catch,
          result: []
        }
      }
    }
    else {
      return {
        isSuccess: false,
        message: Values.MessageValues.erro_catch,
        result: []
      };
    }

  } catch (e) {
    return {
      isSuccess: false,
      message: Values.MessageValues.erro_catch,
      result: []
    };

  }
}

async function getEstoqueInsumoMovimentacaoFiltrado(limit, page, descricaoInsumo, idsInsumos, dataInicio, dataFim, tipoMovimentacao) {
  try {
    const timeout = ServiceValues.timeout;
    const baseUrl = ServiceValues.base_url_local;
    const api = ServiceAxios(baseUrl, timeout);
    const params = {
      limit: limit,
      page: page,
      descricaoInsumo: descricaoInsumo,
      idsInsumos: idsInsumos,
      dataInicio: dataInicio,
      dataFim: dataFim,
      tipoMovimentacao: tipoMovimentacao
    };
    const dados = await api.get('estoque-insumo-movimentacao/filter/', { params: params });
    if (dados) {
      if (dados.data) {
        return dados.data;
      }
      else {
        return {
          isSuccess: false,
          message: Values.MessageValues.erro_catch,
          result: []
        }
      }
    }
    else {
      return {
        isSuccess: false,
        message: Values.MessageValues.erro_catch,
        result: []
      };
    }

  } catch (e) {
    return {
      isSuccess: false,
      message: Values.MessageValues.erro_catch,
      result: []
    };

  }
}

async function getEstoqueInsumoMovimentacaoMetadadosFiltrado(descricaoInsumo, idsInsumos, dataInicio, dataFim, tipoMovimentacao) {
  try {
    const timeout = ServiceValues.timeout;
    const baseUrl = ServiceValues.base_url_local;
    const api = ServiceAxios(baseUrl, timeout);
    const params = {
      descricaoInsumo: descricaoInsumo,
      idsInsumos: idsInsumos,
      dataInicio: dataInicio,
      dataFim: dataFim,
      tipoMovimentacao: tipoMovimentacao
    };
    const dados = await api.get('estoque-insumo-movimentacao/metadados/', { params: params });
    if (dados) {
      if (dados.data) {
        return dados.data;
      }
      else {
        return {
          isSuccess: false,
          message: Values.MessageValues.erro_catch,
          result: []
        }
      }
    }
    else {
      return {
        isSuccess: false,
        message: Values.MessageValues.erro_catch,
        result: []
      };
    }

  } catch (e) {
    return {
      isSuccess: false,
      message: Values.MessageValues.erro_catch,
      result: []
    };

  }
}

async function getEstoqueInsumoMovimentacaoFiltradoPorInsumo(limit, page, descricaoInsumo, idsInsumos, dataInicio, dataFim, tipoMovimentacao) {
  try {
    const timeout = ServiceValues.timeout;
    const baseUrl = ServiceValues.base_url_local;
    const api = ServiceAxios(baseUrl, timeout);
    const params = {
      limit: limit,
      page: page,
      descricaoInsumo: descricaoInsumo,
      idsInsumos: idsInsumos,
      dataInicio: dataInicio,
      dataFim: dataFim,
      tipoMovimentacao: tipoMovimentacao
    };
    const dados = await api.get('estoque-insumo-movimentacao/filter/insumo', { params: params });
    if (dados) {
      if (dados.data) {
        return dados.data;
      }
      else {
        return {
          isSuccess: false,
          message: Values.MessageValues.erro_catch,
          result: []
        }
      }
    }
    else {
      return {
        isSuccess: false,
        message: Values.MessageValues.erro_catch,
        result: []
      };
    }

  } catch (e) {
    return {
      isSuccess: false,
      message: Values.MessageValues.erro_catch,
      result: []
    };

  }
}

async function getEstoqueInsumoMovimentacaoFiltradoPorInsumoComMovimentacoes(limit, page, descricaoInsumo, idsInsumos, dataInicio, dataFim, tipoMovimentacao) {
  try {
    const timeout = ServiceValues.timeout;
    const baseUrl = ServiceValues.base_url_local;
    const api = ServiceAxios(baseUrl, timeout);
    const params = {
      limit: limit,
      page: page,
      descricaoInsumo: descricaoInsumo,
      idsInsumos: idsInsumos,
      dataInicio: dataInicio,
      dataFim: dataFim,
      tipoMovimentacao: tipoMovimentacao
    };
    const dados = await api.get('estoque-insumo-movimentacao/filter/insumo/movimentacoes', { params: params });
    if (dados) {
      if (dados.data) {
        return dados.data;
      }
      else {
        return {
          isSuccess: false,
          message: Values.MessageValues.erro_catch,
          result: []
        }
      }
    }
    else {
      return {
        isSuccess: false,
        message: Values.MessageValues.erro_catch,
        result: []
      };
    }

  } catch (e) {
    return {
      isSuccess: false,
      message: Values.MessageValues.erro_catch,
      result: []
    };

  }
}


export {
  getAllEstoqueInsumoMovimentacao,
  getEstoqueInsumoMovimentacaoFiltrado,
  getEstoqueInsumoMovimentacaoMetadadosFiltrado,
  getEstoqueInsumoMovimentacaoFiltradoPorInsumo,
  getEstoqueInsumoMovimentacaoFiltradoPorInsumoComMovimentacoes
};
